const transformServerSideRequest = (serverSideData) => {
  let { start, length, draw, filters, search, order, columns } = serverSideData;

  let requestDefinition = {
    columns: []
    , start: start * length - length
    , length
    , search
    , filters
    , draw
  };

  const columnsObjectKey = Object.keys(columns);

  let iterColumn = 0;
  let sortBy = [];
  let dirBy = [];
  columnsObjectKey.forEach((item) => {
    const column = columns[item];

    requestDefinition.columns[iterColumn] = {
      data: column.value ? column.value : ""
      , name: column.value ? column.value : ""
      , searchable: column.searchable ? column.searchable : false
      , orderable: column.sortable ? column.sortable : false
      , search: {
        value: ""
        , regex: false
      }
    };

    if (order.column && order.column.includes(column.value)) {
      sortBy.push(iterColumn);
      dirBy.push(order.dir[order.column.indexOf(column.value)] ? "desc" : "asc");
      requestDefinition.columns[iterColumn].order = { column: iterColumn, dir: order.dir[order.column.indexOf(column.value)] ? "desc" : "asc" };
    }

    iterColumn++;
  });

  if (order) {
    order.column = sortBy;
    order.dir = dirBy;
    requestDefinition.order = order;
  }

  return requestDefinition;
};

export default { transformServerSideRequest };



// WEBPACK FOOTER //
// ./src/helpers/server-side-datatable.js